import { Subject } from 'rxjs';

import { Variant } from '@ap/amounts';
import { MijnWebcomponentIdentifier } from '@ap/mijn-navigatie';

import { Breadcrumb } from '../mijn-overzicht-template/breadcrumb/breadcrumb.model';
import { FeedbackConfiguration } from '../mijn-overzicht-template/mijn-overzicht-template.model';

export enum MijnOmgevingTemplates {
    EMPTY = 'EMPTY',
    OVERZICHT = 'OVERZICHT',
    ACTIE = 'ACTIE',
    LOGIN = 'LOGIN',
    MOBILE = 'MOBILE'
}

export enum TemplateClickEvent {
    PRIMARYACTION = 'PRIMARYACTION',
    SECONDARYACTION = 'SECONDARYACTION',
    CLOSETEMPLATE = 'CLOSETEMPLATE',
    CHATNOTIFICATION = 'CHATNOTIFICATION'
}

export interface TemplateClickActions {
    webcomponentName: MijnWebcomponentIdentifier;
    eventActions: EventAction[];
}

export interface EventAction {
    event: TemplateClickEvent;
    action: any;
}

interface TemplateActions {
    webcomponentIdentifier: MijnWebcomponentIdentifier;
    primaryActionClicked?: any;
    secondaryActionClicked?: any;
    chatNotificationSent?: any;
    closeTemplate?: any;
    tabTitle?: string;
}

export interface OverzichtTemplateSettings extends TemplateActions {
    title: string;
    breadcrumb?: Breadcrumb;
    subtitle?: string;
    secondarySubtitle?: string;
    amount?: number;
    amountVariant?: Variant;
    amountContrast?: boolean;
    secondarySubAmount?: number;
    primaryActionLabel?: string;
    secondaryActionLabel?: string;
    variant?: 'primary' | 'secondary';
    loading?: boolean;
    avatar?: string;
    /** Updates the dynamic breadcrumb and should be used when a router-outlet is used inside the template */
    updateURL?: string;
    feedbackConfiguration?: FeedbackConfiguration;
    updateUnreadMessages$?: Subject<void>;
    updatePendingActions$?: Subject<void>;
    changeConversationalStatus?: Subject<string>;
    setTemplate?: MijnOmgevingTemplates;
    showHeaderItems?: boolean;
}

export interface ActieTemplateSettings extends TemplateActions {
    title: string;
    subtitle?: string;
    fullWidth?: boolean;
    dynamicRouting?: boolean;
    contextHelp?: string;
    setTemplate?: MijnOmgevingTemplates;
    changeConversationalStatus?: Subject<string>;
    showCloseButton?: boolean;
}

export type TemplateSettings = OverzichtTemplateSettings | ActieTemplateSettings;
